export const getFileExtension = (fileName: string): string => {
  return fileName.toLowerCase().slice(fileName.lastIndexOf('.'));
}; 